import SHeading from "@/components/atoms/SHeading";
import BrandItem from "./components/BrandItem";
import { useTranslation } from "react-i18next";

const BrandPartners = () => {
  const { t } = useTranslation();
  return (
    <div className="px-10">
      <div className="flex justify-center items-center mt-10">
        <SHeading
          text={t("home.brand_partners.title")}
          tAlign="center"
          className="font-bold md:text-3xl text-xl mb-8"
        />
      </div>
      <div className="max-w-[1348px] justify-centers justify-between  md:justify-between flex flex-wrap items-center gap-y-1 border-2 px-10 box-border py-4  mx-auto rounded-3xl mb-10  sm:after:content-[''] sm:after:flex-auto">
        <BrandItem />
      </div>
    </div>
  );
};

export default BrandPartners;
